import AnnotationVerificationPage from './AnnotationVerificationPage';

export default AnnotationVerificationPage;
